module.exports = __webpack_public_path__ + "media/img/logos/2024/neujahr-3014ff4596ab075f3c29280b36f93d19.svg";